import { request } from '@/utils/api/request';

import { ENDPOINT } from '@/constants/api';

export const user = {
  getConfig() {
    return request.get({ url: '/config' });
  },
  getJWTData() {
    return request.get({ url: '/users/jwtdata' });
  },
  getUserData() {
    return request.get({ url: '/users', doNotLogout: true });
  },
  setProfileValue(payload) {
    return request.put({ url: '/users', payload });
  },
  betaAccess: {
    getSubscriptions() {
      return request.get({ endpoint: ENDPOINT.AUTH_V2, url: '/beta-access' });
    },
    subscribe({ feature }) {
      return request.post({ endpoint: ENDPOINT.AUTH_V2, payload: { feature }, url: '/beta-access/subscribe' });
    },
    unsubscribe({ featureId }) {
      return request.delete({ endpoint: ENDPOINT.AUTH_V2, url: `/beta-access/unsubscribe/${featureId}` });
    },
  },
};
